export default __webpack_public_path__ + "static/media/coffee-maker.4ce3229c.jpg";